'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadTroubleshootModeTallyCampaign = undefined;
exports.getHubSpotUtk = getHubSpotUtk;
exports.getHubSpotHubId = getHubSpotHubId;
exports.trackHsFormViews = trackHsFormViews;
exports.addHsTrackingCode = addHsTrackingCode;
exports.trackLibVersionInNewRelic = trackLibVersionInNewRelic;

var _once = require('transmute/once');

var _once2 = _interopRequireDefault(_once);

var _utils = require('MeetingsBase/utils/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QA_TROUBLESHOOT_MODE_TALLY_CAMPAIGN_ID = 1774;
var PROD_TROUBLESHOOT_MODE_TALLY_CAMPAIGN_ID = 4436;

function getCookie(name) {
  var cookieValue = null;
  if (document.cookie && document.cookie !== '') {
    var cookies = document.cookie.split(';');
    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i].trim();
      if (cookie.substring(0, name.length + 1) === name + '=') {
        cookieValue = cookie.substring(name.length + 1);
        break;
      }
    }
  }
  return cookieValue;
}

function getHubSpotUtk() {
  return getCookie('hubspotutk');
}

function getHubSpotHubId() {
  return getCookie('hubspot.hub.id');
}

function attachEmbedSpecificCallbacks(portalId, parentPageInfo) {
  var pageId = parentPageInfo.pageId,
      folderId = parentPageInfo.folderId,
      contentType = parentPageInfo.contentType,
      contentGroupId = parentPageInfo.contentGroupId;

  var setPortalId = ['setPortalId', portalId];
  var setCookiePolicy = ['setCookiePolicy', [{
    enabled: true,
    privacyPolicy: 2,
    privacyDefault: true
  }]];
  var setPageId = ['setPageId', pageId || null];
  var setContentType = ['setContentType', contentType || null];
  var setContentMetadata = ['setContentMetadata', {
    contentPageId: pageId || null,
    contentFolderId: folderId || null,
    contentGroupId: contentGroupId || null
  }];
  window._hsq.push(setPortalId);
  window._hsq.push(setCookiePolicy);
  window._hsq.push(setPageId);
  window._hsq.push(setContentType);
  window._hsq.push(setContentMetadata);
}

function trackHsFormViews(formGuid, portalId, parentPageInfo, embedded) {
  if (!formGuid) {
    return;
  }

  var canonicalUrl = ['setCanonicalUrl', (0, _utils.getAnalyticsCanonicalUrl)()];
  var attachFormGuid = ['trackFormView', formGuid, { formType: 5 }];

  window._hsq = window._hsq || [];
  if (embedded) {
    attachEmbedSpecificCallbacks(portalId, parentPageInfo);
  }
  window._hsq.push(canonicalUrl);
  window._hsq.push(attachFormGuid);
}

function addHsTrackingCode(portalId, embedded) {
  var scriptId = 'hs-script-loader';
  if (document.getElementById(scriptId)) {
    return;
  }
  var hsAnalyticsScript = document.createElement('script');
  hsAnalyticsScript.async = true;
  hsAnalyticsScript.id = scriptId;
  hsAnalyticsScript.src = (0, _utils.getAnalyticsScriptSource)(portalId, embedded);
  document.body.appendChild(hsAnalyticsScript);
}

// MeetingsLib version is more valuable in New Relic alongside
// other metrics since MeetingsPublic is rarely deployed
function trackLibVersionInNewRelic() {
  if (window.newrelic && window.newrelic.setCustomAttribute && typeof window.newrelic.setCustomAttribute === 'function' && window.hubspot && window.hubspot.bender && window.hubspot.bender.depVersions && window.hubspot.bender.depVersions.MeetingsLib) {
    window.newrelic.setCustomAttribute('meetingsLibVersion', window.hubspot.bender.depVersions.MeetingsLib);
  }
}

// Tally will not always be on the page
// and we don't want to load it twice no matter what
var loadTroubleshootModeTallyCampaign = exports.loadTroubleshootModeTallyCampaign = (0, _once2.default)(function () {
  if (window.hubspot && window.hubspot.tally && typeof window.hubspot.tally.loadCampaign === 'function') {
    var tallyCampaign = (0, _utils.isQA)() ? QA_TROUBLESHOOT_MODE_TALLY_CAMPAIGN_ID : PROD_TROUBLESHOOT_MODE_TALLY_CAMPAIGN_ID;
    window.hubspot.tally.loadCampaign(tallyCampaign);
  }
});


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/utils/analytics.js
// module id = 90
// module chunks = 0